<template>
  <div class="flex min-h-screen flex-col bg-blue-lighter">
    <Header hideNav />
    <main class="mb-20 flex grow flex-col">
      <slot></slot>
    </main>
  </div>
</template>
